import type { ReactNode } from "react";
import s from "./FieldFooter.module.scss";

interface FieldFooterProps {
    children: ReactNode;
}

export function FieldFooter({ children }: FieldFooterProps) {
    return <div className={s.fieldFooter}>{children}</div>;
}
